<template>
  <form @submit.prevent="$emit('submit')">
    <div v-for="row in fields" class="row">
      <div v-for="field in row" :class="'col-md-' + field.width">
        <div v-if="field.widget === 'text'" class="form-group">
          <input
              :value="value[field.name]"
              type="text"
              class="form-control input-sm"
              :placeholder="field.placeholder || 'Search...'"
              @input="input(field.name, $event.target.value)"
          >
        </div>

        <div v-else-if="field.widget === 'date'" class="form-group">
          <date-widget
              input-class="input-sm"
              :value="value[field.name]"
              :name="field.name"
              :disabled="disabled"
              :placeholder="field.placeholder"
              :format="field.format"
              :original-format="field.originalFormat"
              @input="input(field.name, $event)"
          ></date-widget>
        </div>

        <div v-else-if="field.widget === 'select'" class="form-group">
          <select-widget
              input-class="input-sm"
              :value="value[field.name]"
              :name="field.name"
              :disabled="disabled"
              :options="field.options"
              :nullable="field.nullable"
              :placeholder="field.placeholder"
              @input="input(field.name, $event)"
          ></select-widget>
        </div>

        <div v-else-if="field.widget === 'tags'" class="form-group">
          <TagsWidget
              :value="value[field.name]"
              :name="field.name"
              @input="input(field.name, $event)"
          />
        </div>

        <div v-else-if="field.widget === 'new-tags'" class="form-group">
          <NewTagsWidget
              :value="value[field.name]"
              :name="field.name"
              @input="input(field.name, $event)"
          />
        </div>

        <div v-else-if="field.widget === 'typeahead'" class="form-group">
          <TypeaheadWidget
              input-class="input-sm"
              :value="value[field.name]"
              :name="field.name"
              :endpoint="field.endpoint"
              :token="shared.token"
              path="data.data"
              :placeholder="field.placeholder"
              :load-initial="true"
              :result-label-property="field.resultLabelProperty ? field.resultLabelProperty : (row) => row.attributes.name"
              @input="input(field.name, $event)"
          />
        </div>

        <div v-else-if="field.widget === 'submit'">
          <button
              type="submit"
              class="btn btn-black btn-block btn-sm"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
        </div>

        <div v-else-if="field.widget === 'button'">
          <button
              type="button"
              class="btn btn-block btn-sm"
              :class="field.class || 'btn-black'"
              v-html="field.text"
              @click="$emit('click', field.event)"
          >
          </button>
        </div>

        <div v-else>
          &nbsp;
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import store from '@/store'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import NewTagsWidget from '../FormGroups/Widgets/NewTags'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TagsWidget from '../FormGroups/Widgets/Tags'
import TypeaheadWidget from "../../vendor/forms/FormGroups/Widgets/Typeahead"

export default {
  components: {TypeaheadWidget, DateWidget, NewTagsWidget, SelectWidget, TagsWidget},

  props: {
    fields: {
      required: true,
      type: Array
    },

    value: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    },

    disabled: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      shared: store
    }
  },

  methods: {
    input(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
